module.exports = __webpack_public_path__ + "static/Bedlam-b16c85f7c0d4b1c0c1ab3599f718c265.jpg";